import { useMemo } from "react"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  calculateCasilla155,
  calculateCasilla172,
  calculateCasilla189,
} from "../calculodeTotales"
import GroupTemplate from "./GroupTemplate"

const ActividadesRegimenesDeduccionDiferenciados = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()

  const casilla155 = useMemo(() => {
    const result = calculateCasilla155(values)
    setValue("casilla155", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla140,
    values?.casilla142,
    values?.casilla144,
    values?.casilla146,
    values?.casilla148,
    values?.casilla150,
    values?.casilla152,
    values?.casilla153,
    values?.casilla154,
  ])

  const casilla172 = useMemo(() => {
    const result = calculateCasilla172(values)
    setValue("casilla172", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla157,
    values?.casilla159,
    values?.casilla161,
    values?.casilla163,
    values?.casilla165,
    values?.casilla167,
    values?.casilla169,
    values?.casilla170,
    values?.casilla171,
  ])

  const casilla189 = useMemo(() => {
    const result = calculateCasilla189(values)
    setValue("casilla189", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla174,
    values?.casilla176,
    values?.casilla178,
    values?.casilla180,
    values?.casilla182,
    values?.casilla184,
    values?.casilla186,
    values?.casilla187,
    values?.casilla188,
  ])

  const fieldsGroupOne: $TSMigrationFixMe[] = [
    {
      section: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.section1"
      ),
      labelOne: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box1"
      ),
      inputsOne: [
        {
          code: "casilla139",
          inputNumber: "139",
          value: values?.casilla139,
        },
        {
          code: "casilla140",
          inputNumber: "140",
          value: values?.casilla140,
        },
      ],
      labelTwo: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box2"
      ),
      inputsTwo: [
        {
          code: "casilla141",
          inputNumber: "141",
          value: values?.casilla141,
        },
        {
          code: "casilla142",
          inputNumber: "142",
          value: values?.casilla142,
        },
      ],
    },
    {
      section: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.section2"
      ),
      labelOne: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box3"
      ),
      inputsOne: [
        {
          code: "casilla143",
          inputNumber: "143",
          value: values?.casilla143,
        },
        {
          code: "casilla144",
          inputNumber: "144",
          value: values?.casilla144,
        },
      ],
      labelTwo: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box4"
      ),
      inputsTwo: [
        {
          code: "casilla145",
          inputNumber: "145",
          value: values?.casilla145,
        },
        {
          code: "casilla146",
          inputNumber: "146",
          value: values?.casilla146,
        },
      ],
    },
    {
      section: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.section3"
      ),
      labelOne: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box5"
      ),
      inputsOne: [
        {
          code: "casilla147",
          inputNumber: "147",
          value: values?.casilla147,
        },
        {
          code: "casilla148",
          inputNumber: "148",
          value: values?.casilla148,
        },
      ],
      labelTwo: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box4"
      ),
      inputsTwo: [
        {
          code: "casilla149",
          inputNumber: "149",
          value: values?.casilla149,
        },
        {
          code: "casilla150",
          inputNumber: "150",
          value: values?.casilla150,
        },
      ],
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box6"),
      inputsOne: [
        {
          code: "casilla151",
          inputNumber: "151",
          value: values?.casilla151,
        },
        {
          code: "casilla152",
          inputNumber: "152",
          value: values?.casilla152,
        },
      ],
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box7"),
      inputsOne: [
        {
          code: "casilla640",
          inputNumber: "640",
          value: values?.casilla640,
        },
        {
          code: "casilla153",
          inputNumber: "153",
          value: values?.casilla153,
        },
      ],
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box8"),
      code: "casilla154",
      inputNumber: "154",
      value: values?.casilla154,
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box9"),
      code: "casilla155",
      inputNumber: "155",
      value: casilla155,
      disabled: true,
    },
  ]

  const fieldsGroupTwo = [
    {
      section: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.section1"
      ),
      labelOne: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box1"
      ),
      inputsOne: [
        {
          code: "casilla156",
          inputNumber: "156",
          value: values?.casilla156,
        },
        {
          code: "casilla157",
          inputNumber: "157",
          value: values?.casilla157,
        },
      ],
      labelTwo: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box2"
      ),
      inputsTwo: [
        {
          code: "casilla158",
          inputNumber: "158",
          value: values?.casilla158,
        },
        {
          code: "casilla159",
          inputNumber: "159",
          value: values?.casilla159,
        },
      ],
    },
    {
      section: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.section2"
      ),
      labelOne: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box3"
      ),
      inputsOne: [
        {
          code: "casilla160",
          inputNumber: "160",
          value: values?.casilla160,
        },
        {
          code: "casilla161",
          inputNumber: "161",
          value: values?.casilla161,
        },
      ],
      labelTwo: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box4"
      ),
      inputsTwo: [
        {
          code: "casilla162",
          inputNumber: "162",
          value: values?.casilla162,
        },
        {
          code: "casilla163",
          inputNumber: "163",
          value: values?.casilla163,
        },
      ],
    },
    {
      section: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.section3"
      ),
      labelOne: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box5"
      ),
      inputsOne: [
        {
          code: "casilla164",
          inputNumber: "164",
          value: values?.casilla164,
        },
        {
          code: "casilla165",
          inputNumber: "165",
          value: values?.casilla165,
        },
      ],
      labelTwo: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box4"
      ),
      inputsTwo: [
        {
          code: "casilla166",
          inputNumber: "166",
          value: values?.casilla166,
        },
        {
          code: "casilla167",
          inputNumber: "167",
          value: values?.casilla167,
        },
      ],
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box10"),
      inputsOne: [
        {
          code: "casilla168",
          inputNumber: "168",
          value: values?.casilla168,
        },
        {
          code: "casilla169",
          inputNumber: "169",
          value: values?.casilla169,
        },
      ],
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box7"),
      inputsOne: [
        {
          code: "casilla641",
          inputNumber: "641",
          value: values?.casilla641,
        },
        {
          code: "casilla170",
          inputNumber: "170",
          value: values?.casilla170,
        },
      ],
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box8"),
      code: "casilla171",
      inputNumber: "171",
      value: values?.casilla171,
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box11"),
      code: "casilla172",
      inputNumber: "172",
      value: casilla172,
      disabled: true,
    },
  ]

  const fieldsGroupThree = [
    {
      section: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.section1"
      ),
      labelOne: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box1"
      ),
      inputsOne: [
        {
          code: "casilla173",
          inputNumber: "173",
          value: values?.casilla173,
        },
        {
          code: "casilla174",
          inputNumber: "174",
          value: values?.casilla174,
        },
      ],
      labelTwo: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box2"
      ),
      inputsTwo: [
        {
          code: "casilla175",
          inputNumber: "175",
          value: values?.casilla175,
        },
        {
          code: "casilla176",
          inputNumber: "176",
          value: values?.casilla176,
        },
      ],
    },
    {
      section: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.section2"
      ),
      labelOne: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box3"
      ),
      inputsOne: [
        {
          code: "casilla177",
          inputNumber: "177",
          value: values?.casilla177,
        },
        {
          code: "casilla178",
          inputNumber: "178",
          value: values?.casilla178,
        },
      ],
      labelTwo: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box2"
      ),
      inputsTwo: [
        {
          code: "casilla179",
          inputNumber: "179",
          value: values?.casilla179,
        },
        {
          code: "casilla180",
          inputNumber: "180",
          value: values?.casilla180,
        },
      ],
    },
    {
      section: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.section3"
      ),
      labelOne: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box5"
      ),
      inputsOne: [
        {
          code: "casilla181",
          inputNumber: "181",
          value: values?.casilla181,
        },
        {
          code: "casilla182",
          inputNumber: "182",
          value: values?.casilla182,
        },
      ],
      labelTwo: t(
        "taxSummary.declaracion.regimenesDeduccionDiferenciados.box2"
      ),
      inputsTwo: [
        {
          code: "casilla183",
          inputNumber: "183",
          value: values?.casilla183,
        },
        {
          code: "casilla184",
          inputNumber: "184",
          value: values?.casilla184,
        },
      ],
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box6"),
      inputsOne: [
        {
          code: "casilla185",
          inputNumber: "185",
          value: values?.casilla185,
        },
        {
          code: "casilla186",
          inputNumber: "186",
          value: values?.casilla186,
        },
      ],
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box7"),
      inputsOne: [
        {
          code: "casilla642",
          inputNumber: "642",
          value: values?.casilla642,
        },
        {
          code: "casilla187",
          inputNumber: "187",
          value: values?.casilla187,
        },
      ],
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box8"),
      code: "casilla188",
      inputNumber: "188",
      value: values?.casilla188,
    },
    {
      label: t("taxSummary.declaracion.regimenesDeduccionDiferenciados.box12"),
      code: "casilla189",
      inputNumber: "189",
      value: casilla189,
      disabled: true,
    },
  ]

  return (
    <div
      title='RegimenesDeduccionDiferenciados'
      className='tw-space-y-4 tw-w-full tw-px-4'
    >
      <GroupTemplate
        groupTitle='IVA deducible: Grupo 1'
        fields={fieldsGroupOne}
        setValue={setValue}
      />
      <GroupTemplate
        groupTitle='IVA deducible: Grupo 2'
        fields={fieldsGroupTwo}
        setValue={setValue}
      />
      <GroupTemplate
        groupTitle='IVA deducible: Grupo 3'
        fields={fieldsGroupThree}
        setValue={setValue}
      />
    </div>
  )
}

export default ActividadesRegimenesDeduccionDiferenciados
